import { observer } from 'mobx-react';
import React from 'react';
import { Button, Image } from '@udemy/react-core-components';
import { useUDData } from '@udemy/ud-data';
import { udemyBenesseLogoInvertedUrl } from '../../external/utils/udemy-logo-urls';
export const Logos = observer(({
  isJpFooter
}) => {
  const {
    Config
  } = useUDData();
  const logoHeight = 34;
  const udemyBenesseLogoHeight = 43; // Chosen so the 'Udemy' portion of the combined logo matches the normal Udemy logo.
  const udemyBenesseLogoAspectRatio = 1501 / 268; // Aspect ratio of the combined logo. Used to calculate the displayed width.

  const logos = [
  // First logo is always Udemy
  // in UB China, this is both UB logo and sanjieke logo
  {
    src: Config.brand.product_logo_light,
    alt: Config.brand.product_name,
    width: logoHeight * Config.brand.product_logo_aspect_ratio,
    height: logoHeight
  }];

  // Replace the Udemy logo with a combined Udemy and Benesse logo in Marketplace Japan.
  if (isJpFooter && !Config.brand.has_organization) {
    logos[0] = {
      src: udemyBenesseLogoInvertedUrl,
      alt: 'Udemy-Benesse-Logo',
      width: udemyBenesseLogoHeight * udemyBenesseLogoAspectRatio,
      height: udemyBenesseLogoHeight
    };
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, logos.map((logo, i) => {
    if (i === 0) {
      return /*#__PURE__*/React.createElement(Button, {
        key: logo.alt,
        componentClass: "a",
        udStyle: "link",
        href: "/"
      }, /*#__PURE__*/React.createElement(Image, Object.assign({}, logo, {
        lazy: false
      })));
    }
    return /*#__PURE__*/React.createElement(Image, Object.assign({
      key: logo.alt
    }, logo, {
      lazy: false
    }));
  }));
});
//# sourceMappingURL=logos.react-component.js.map